import { render } from "./Nudge.vue?vue&type=template&id=ecc4034e"
import script from "./Nudge.vue?vue&type=script&lang=js"
export * from "./Nudge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/messages/Nudge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ecc4034e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ecc4034e', __exports__)) {
    api.reload('ecc4034e', __exports__)
  }
  
  module.hot.accept("./Nudge.vue?vue&type=template&id=ecc4034e", () => {
    api.rerender('ecc4034e', render)
  })

}


export default __exports__